import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const InterviewFeedbackModal = ({ show, onClose, feedbackData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";

    if (show) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
      setTimeout(() => setShouldRender(false), 500);
    }

    return () => (document.body.style.overflow = "auto");
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[70] flex justify-end transition-opacity duration-500
      ${isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"}`}
      onClick={(e) => handleOutsideClick(e, onClose)}
    >
      {/* Drawer */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`
          bg-white h-full w-[60%]
          shadow-[ -10px_0px_30px_rgba(0,0,0,0.15) ]
          flex flex-col
          transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]
          ${isVisible ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">Interview Feedback</h2>
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6">
          {feedbackData?.feedbacks?.length > 0 ? (
            <div className="bg-gray-50 rounded-xl p-5 shadow-sm">
              <h3 className="text-primary font-semibold uppercase text-sm mb-4">
                Feedback
              </h3>

              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-gray-300 table-fixed">
                  <thead className="bg-blue-100 text-center">
                    <tr>
                      <th className="p-2 border w-[40%] text-left">Question</th>
                      <th className="p-2 border w-[50%] text-left">Remark</th>
                      <th className="p-2 border w-[10%]">Rating</th>
                    </tr>
                  </thead>

                  <tbody>
                    {feedbackData.feedbacks.map((fb, index) => (
                      <tr key={index} className="border-t text-center">
                        {/* Question */}
                        <td className="p-3 border text-left break-words">
                          {fb.question}
                        </td>

                        {/* Remark */}
                        <td className="p-3 border text-left break-words">
                          {fb.remark || "-"}
                        </td>

                        {/* Rating */}
                        <td className="p-3 border">
                          {fb.questionID === 1 ? (
                            <span
                              className={`px-3 py-1 rounded-full text-xs text-white ${
                                fb.rating === "1"
                                  ? "bg-green-500"
                                  : "bg-red-500"
                              }`}
                            >
                              {fb.rating === "1" ? "Yes" : "No"}
                            </span>
                          ) : (
                            <span className="px-3 py-1 rounded-full text-xs bg-green-500 text-white">
                              {fb.rating || "-"}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className="text-center text-gray-500">No feedback available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InterviewFeedbackModal;
